// PC详情页浏览
export const EVENT_ID_PRODUCT_VIEW = '11294308924090368';
// PC立即报名按钮点击
export const EVENT_ID_SIGNUP = '11294312300439552';
// PC直播中点击
export const EVENT_ID_LIVING = '11294313869633536';
// PC去上课点击
export const EVENT_ID_STUDY = '11294315582023680';
// PC服务点击
export const EVENT_ID_SERVICE = '11294316855191552';
// PC咨询点击
export const EVENT_ID_CONSULT = '11294318175348736';
// PC老师点击
export const EVENT_ID_TEACHER = '11294327263684608';
// PC课程推荐点击
export const EVENT_ID_RECOMMEND = '11294328493008896';
// PC免费试听
export const EVENT_ID_FREE_VIDEO = '11419462163458048';
// PC商品关联弹窗
export const EVENT_ID_PRODUCT_ASSOCIATION = '11419464614307840';
// PC优惠弹窗
export const EVENT_ID_PROMOTION = '11419467161954304';